import styled from 'styled-components';

export interface WidthProps {
  width?: string;
}

const Div = styled.div`
  width: 100%;
  background-color: #ffffff;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Table = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #222222;
`;

const TopDescription = styled.div`
  width: 100%;
  display: flex;
  font-size: 13px;
  font-weight: 500;
  color: #222222;
`;

const TableHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: #f7f8fc;
  font-size: 13px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 8px 10px;
`;

const Header = styled.div<WidthProps>`
  width: ${(props) => props.width || '50%'};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
  border-bottom: 1px solid #e5e8ea;
  &:last-child {
    border-bottom: none;
  }
`;

const RowLeft = styled.div<WidthProps>`
  width: 160px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RowRight = styled.div`
  width: calc(100% - 160px);
  height: 100%;
  padding-right: 40px;
  align-items: end;
  justify-content: center;
`;

const BottomDescription = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  align-items: start;
  font-size: 13px;
  font-weight: 500;
  color: #222222;
  background-color: #f0f8ff;
  border-radius: 16px;
  letter-spacing: calc(13px * -0.02);
`;

export const s = {
  Div,
  Table,
  Title,
  TopDescription,
  TableHeader,
  Header,
  Row,
  RowLeft,
  RowRight,
  BottomDescription,
};
